/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. All conversions happen in your browser — your text is never sent to a server.`)
};

const es_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Todas las conversiones ocurren en tu navegador — tu texto nunca se envía a un servidor.`)
};

const de_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Alle Konvertierungen finden in deinem Browser statt — dein Text wird niemals an einen Server gesendet.`)
};

const nl_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alle conversies gebeuren in uw browser — uw tekst wordt nooit naar een server verzonden.`)
};

const fr_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Toutes les conversions se font dans votre navigateur — votre texte n'est jamais envoyé à un serveur.`)
};

const it_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutte le conversioni avvengono nel tuo browser — il tuo testo non viene mai inviato a un server.`)
};

const pt_br2_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todas as conversões acontecem no seu navegador — seu texto nunca é enviado para um servidor.`)
};

const pt_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Todas as conversões acontecem no seu navegador — seu texto nunca é enviado para um servidor.`)
};

const ja_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべての変換はブラウザで実行されます — テキストはサーバーに送信されません。`)
};

const zh_cc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有转换都在您的浏览器中完成——您的文本永远不会被发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq2_a", locale)
	if (locale === "en") return en_cc_faq2_a(inputs)
	if (locale === "es") return es_cc_faq2_a(inputs)
	if (locale === "de") return de_cc_faq2_a(inputs)
	if (locale === "nl") return nl_cc_faq2_a(inputs)
	if (locale === "fr") return fr_cc_faq2_a(inputs)
	if (locale === "it") return it_cc_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq2_a(inputs)
	if (locale === "pt") return pt_cc_faq2_a(inputs)
	if (locale === "ja") return ja_cc_faq2_a(inputs)
	return zh_cc_faq2_a(inputs)
};